import ButtonProgress from './ButtonProgress'

export default ButtonProgress
// eslint-disable-next-line import/export
export * from './ButtonProgress'
